import React, { useState, useEffect } from 'react';
import { Save, X } from 'lucide-react';
import { FarmerDto, CreateFarmerDto, UpdateFarmerDto } from '../../../services/api';

interface FarmerFormProps {
  farmer?: FarmerDto;
  onSave: (data: CreateFarmerDto | UpdateFarmerDto) => Promise<void>;
  onCancel: () => void;
  isLoading: boolean;
}

export const FarmerForm: React.FC<FarmerFormProps> = ({
  farmer,
  onSave,
  onCancel,
  isLoading,
}) => {
  const [formData, setFormData] = useState<CreateFarmerDto & { isActive?: boolean }>({
    name: farmer?.name || '',
    externalId: farmer?.externalId || '',
    isActive: farmer?.isActive ?? true,
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">
          Nombre del Agricultor *
        </label>
        <input
          type="text"
          required
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          placeholder="ej: Pepe García"
          className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">
          ID Externo *
        </label>
        <input
          type="text"
          required
          value={formData.externalId}
          onChange={(e) => setFormData({ ...formData, externalId: e.target.value })}
          placeholder="ej: AGR001"
          className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
        />
        <p className="text-xs text-slate-500 mt-1">
          Identificador único del agricultor en el sistema externo
        </p>
      </div>

      {farmer && (
        <div>
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={formData.isActive}
              onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
              className="w-4 h-4 text-green-600 rounded border-slate-300 focus:ring-green-500"
            />
            <span className="text-sm font-medium text-slate-700">Agricultor activo</span>
          </label>
        </div>
      )}

      <div className="flex justify-end gap-3 pt-4 border-t border-slate-100">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-slate-700 hover:bg-slate-100 rounded-lg transition-colors font-medium"
        >
          Cancelar
        </button>
        <button
          type="submit"
          disabled={isLoading}
          className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? (
            <>
              <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
              Guardando...
            </>
          ) : (
            <>
              <Save size={18} />
              {farmer ? 'Actualizar' : 'Crear'} Agricultor
            </>
          )}
        </button>
      </div>
    </form>
  );
};
